import { render, staticRenderFns } from "./VMarkdownView.vue?vue&type=template&id=598f729a&scoped=true&"
import script from "./VMarkdownView.vue?vue&type=script&lang=js&"
export * from "./VMarkdownView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598f729a",
  null
  
)

export default component.exports